// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkOutlinedSvg from "@ant-design/icons-svg/es/asn/TrademarkOutlined";
import AntdIcon from '../components/AntdIcon';

var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkOutlinedSvg
  }));
};

TrademarkOutlined.displayName = 'TrademarkOutlined';
export default React.forwardRef(TrademarkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TrademarkOutlined.js
// module id = 1953
// module chunks = 0